export const SUBTEXT_ID = 'money-input-subtext';
export const MONEY_INPUT_ID = 'money-input-field';
